import {storeSet, authPageCheck} from "@/mixins/Auth.js";

export default [
    {
        path: "/",
        component: () => import('../views/gift/Ttoba.vue'),
        // component: Home,
        // component: setViewResolver("auth/Login"),
        name: "Home",
        // meta: {name: "Home", title: "홈"},


        beforeEnter: storeSet,
        meta: {
            name: "Home", title: "홈",
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},

        },
        redirect: '/ttoba'
    },
    {
        path: '/item',
        redirect: '/'
    },
    {
        path: '/auth/login',
        redirect: '/auth'
    },

    {
        path: '/subscript',
        redirect: '/live?tab=single'
    },
    {
        path: "/auth",
        component: () => import('../views/auth/Login.vue'),
        name: "Login",
        // beforeEnter: authPageCheck,
        meta: {title: '로그인',},
    },
    {
        path: "/auth/find/id",
        component: () => import('../views/auth/FindId.vue'),
        name: "FindId",
        // beforeEnter: authPageCheck,
        meta: {title: '아이디(이메일) 찾기',},
    },
    {
        path: "/auth/register",
        component: () => import('../views/auth/Register.vue'),
        name: "Register",
        meta: {title: '회원가입',},
    },
    {
        path: "/auth/social/register",
        component: () => import('../views/auth/RegisterSocial.vue'),
        name: "RegisterSocial",
        meta: {title: '소셜 회원가입',},
    },
    {
        // 카카오 로그인 콜백(간편가입 동의창 인가코드 수신)
        path: "/auth/kakao/callback",
        component: () => import('../views/auth/KakaoCallback.vue'),
        name: "KakaoCallback",
        meta: {title: '로그인',},
    },
    {
        // 마케팅 목적 개인정보 수집·이용 동의 안내(공개, 카카오 간편가입 약관 URL 대응)
        path: "/auth/register/terms/marketing",
        component: () => import('../views/auth/RegisterMarketingTerms.vue'),
        name: "RegisterMarketingTerms",
        meta: {title: '마케팅 개인정보 수집·이용 동의',},
    },
    {
        // 이용약관(1)·개인정보처리방침(2) 단독 페이지(공개, 카카오 간편가입 약관 URL 대응)
        path: "/auth/register/terms/:key",
        component: () => import('../views/auth/RegisterTerms.vue'),
        name: "RegisterTerms",
        meta: {title: '약관',},
    },
    // {
    //     // 아이디찾기 완료
    //     path: "/auth/find/id/result",
    //     component: setViewResolver("auth/FindIdResult"),
    //     name: "FindIdResult",
    //     meta: { name: "FindIdResult", title: "아이디(이메일) 찾기" },
    // },
    {
        // 비밀번호찾기
        path: "/auth/find/pass",
        component: () => import('../views/auth/FindPass.vue'),
        name: "FindPass",
        meta: {name: "FindPass", title: "비밀번호 찾기"},
    },
    {
        // 비밀번호 찾기 완료
        path: "/auth/find/pass/result",
        component: () => import('../views/auth/FindPassResult.vue'),
        name: "FindPassResult",
        meta: {name: "FindPassResult", title: "비밀번호 찾기"},
    },
    {
        // 회원가입완료
        path: "/auth/register/result",
        component: () => import('../views/auth/RegisterResult.vue'),
        name: "RegisterResult",
        meta: {name: "RegisterResult", title: "회원가입"},
    },
    {
        // 회원가입완료
        path: "/auth/register/partner/result",
        component: () => import('../views/auth/RegisterPartnerResult.vue'),
        name: "RegisterPartnerResult",
        meta: {name: "RegisterPartnerResult", title: "회원가입"},
    },
    {
        path: "/auth/certified/result",
        component: () => import('../views/auth/RegisterNiceResult.vue'),
        name: "RegisterNiceResult",
        meta: {name: "RegisterNiceResult", title: ""},
    },
    {
        path: "/certified/first/result",
        beforeEnter: storeSet,
        component: () => import("../views/auth/AuthNiceResult.vue"),
        name: "AuthNiceFirstResult",
        meta: {name: "AuthNiceResult", title: ""},
    },

    {
        path: "/certified/hp/result",
        beforeEnter: storeSet,
        component: () => import("../views/auth/AuthNiceResult.vue"),
        name: "AuthNiceResultHp",
        meta: {name: "AuthNiceResultHp", title: ""},
    },
    {
        path: "/alarm",
        component: () => import('../views/alarm/Alarm.vue'),
        name: "alarm",
        beforeEnter: storeSet,
        meta: {
            name: "alarm", title: "알림",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    // {
    //     path: '/coin',
    //     component: () => import('../views/Home.vue'),
    //     name: "Coin",
    //     beforeEnter: storeSet,
    //     meta: {
    //         name: "Coin", title: "홈",
    //         storeRequired: true,
    //         authRequired: true,
    //         storeConfig: {userInfo: true},

    //     },
    // },
    {
        path: "/shop",
        component: () => import('../views/shop/Shop.vue'),
        name: "Shop",
        beforeEnter: storeSet,
        meta: {
            name: "Shop", title: "포인트&코인존",
            authRequired: true,
            storeRequired: true,

            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/live",
        component: () => import('../views/live/Live.vue'),
        name: "Live",
        beforeEnter: storeSet,
        meta: {
            name: "Live", title: "라이브 구독",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },

    },
    {
        path: "/live/:idx",
        component: () => import('../views/live/LiveDetail.vue'),
        name: "LiveDetail",
        beforeEnter: storeSet,
        meta: {
            name: "LiveDetail", title: "구독 현황 상세",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },

    },

    {
        path: "/live/item",
        component: () => import('../views/live/LiveItem.vue'),
        name: "LiveItem",
        beforeEnter: storeSet,
        meta: {
            name: "LiveItem", title: "상품",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },

    },
    {
        path: "/live/pay/:idx",
        component: () => import('../views/live/LivePay.vue'),
        name: "LivePay",
        beforeEnter: storeSet,
        meta: {
            name: "LivePay", title: "상품",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },

    },
    {
        path: "/live/done/:idx",
        component: () => import('../views/live/LivePayDone.vue'),
        name: "LivePayDone",
        beforeEnter: storeSet,
        meta: {
            name: "LivePayDone", title: "상품",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },

    },



    {
        path: "/mypage/partner",
        component: () => import('../views/mypage/Partner.vue'),
        name: "Partner",
        beforeEnter: storeSet,
        meta: {
            name: "Partner", title: "파트너",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/partner/register",
        component: () => import('../views/mypage/PartnerRegister.vue'),
        name: "PartnerRegister",
        beforeEnter: storeSet,
        meta: {
            name: "PartnerRegister", title: "이웃파트너 가입",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/partner/register/result",
        component: () => import('../views/mypage/PartnerRegisterResult.vue'),
        name: "PartnerRegisterResult",
        beforeEnter: storeSet,
        meta: {
            name: "PartnerRegisterResult", title: "이웃파트너 가입",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/partner/:type/join",
        component: () => import('../views/mypage/PartnerJoin.vue'),
        name: "PartnerJoin",
        beforeEnter: storeSet,
        meta: {
            name: "PartnerJoin", title: "이웃파트너 가입",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/partner/:type/update",
        component: () => import('../views/mypage/PartnerUpdate.vue'),
        name: "PartnerUpdate",
        beforeEnter: storeSet,
        meta: {
            name: "PartnerUpdate", title: "이웃파트너 수정",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/partner/info",
        component: () => import('../views/mypage/PartnerInfo.vue'),
        name: "PartnerInfo",
        beforeEnter: storeSet,
        meta: {
            name: "PartnerInfo", title: "이웃파트너 정보",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/partner/quit/:type",
        component: () => import('../views/mypage/PartnerQuit.vue'),
        name: "PartnerQuit",
        beforeEnter: storeSet,
        meta: {
            name: "PartnerQuit", title: "권한 해지",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },


    {
        path: "/mypage",
        component: () => import('../views/mypage/Mypage.vue'),
        name: "mypage",
        beforeEnter: storeSet,
        meta: {
            name: "mypage", title: "마이페이지",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/alarm",
        component: () => import('../views/mypage/MypageAlarm.vue'),
        name: "MypageAlarm",
        beforeEnter: storeSet,
        meta: {
            name: "MypageAlarm", title: "알림 설정",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/info",
        component: () => import('../views/mypage/MypageInfo.vue'),
        name: "MypageInfo",
        beforeEnter: storeSet,
        meta: {
            name: "MypageInfo", title: "나의 정보관리",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/info/quit",
        component: () => import('../views/mypage/MypageQuit.vue'),
        name: "MypageQuit",
        beforeEnter: storeSet,
        meta: {
            name: "MypageQuit", title: "회원탈퇴",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/recommend",
        component: () => import('../views/mypage/Recommend.vue'),
        name: "Recommend",
        beforeEnter: storeSet,
        meta: {
            name: "Recommend", title: "추천인 등록현 황",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/history",
        component: () => import('../views/mypage/History.vue'),
        name: "History",
        beforeEnter: storeSet,
        meta: {
            name: "History", title: "결제내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },

        children: [
            {
                path: "/mypage/history/:idx",
                component: () => import('../views/mypage/HistoryDetail.vue'),
                name: "HistoryDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "HistoryDetail", title: "결제상세",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
        ],
    },

    {
        path: "/mypage/shopping/history",
        component: () => import('../views/mypage/ShoppingHistory.vue'),
        name: "ShoppingHistory",
        beforeEnter: storeSet,
        meta: {
            name: "ShoppingHistory", title: "레인보우 쇼핑 구매 내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/shopping/history/cancel",
        component: () => import('../views/mypage/ShoppingHistoryCancel.vue'),
        name: "ShoppingHistoryCancel",
        beforeEnter: storeSet,
        meta: {
            name: "ShoppingHistoryCancel", title: "레인보우 쇼핑 구매 내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/shopping/history/:idx",
        component: () => import('../views/mypage/ShoppingHistoryDetail.vue'),
        name: "ShoppingHistoryDetail",
        beforeEnter: storeSet,
        meta: {
            name: "ShoppingHistoryDetail", title: "레인보우 쇼핑 구매 내역 상세",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/shopping/history/trade/:idx",
        component: () => import('../views/mypage/ShoppingHistoryTradeDetail.vue'),
        name: "ShoppingHistoryTradeDetail",
        beforeEnter: storeSet,
        meta: {
            name: "ShoppingHistoryTradeDetail", title: "레인보우 쇼핑 구매 내역 상세",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/shopping/history/refund/:idx",
        component: () => import('../views/mypage/ShoppingHistoryRefundDetail.vue'),
        name: "ShoppingHistoryRefundDetail",
        beforeEnter: storeSet,
        meta: {
            name: "ShoppingHistoryRefundDetail", title: "레인보우 쇼핑 구매 내역 상세",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    // VOD
    {
        path: "/mypage/vod/history",
        component: () => import('../views/mypage/VodHistory.vue'),
        name: "VodHistory",
        beforeEnter: storeSet,
        meta: {
            name: "VodHistory", title: "레인보우 VOD 구매 내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/vod/history/:idx",
        component: () => import('../views/mypage/VodHistoryDetail.vue'),
        name: "VodHistoryDetail",
        beforeEnter: storeSet,
        meta: {
            name: "VodHistoryDetail", title: "레인보우 VOD 구매 내역 상세",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/shopping/:idx/refund",
        component: () => import("../views/mypage/ShoppingRefundRequest.vue"),
        name: "ShoppingRefundRequest",
        meta: {
            name: "Refund",
            title: '반품 요청',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/shopping/:idx/trade",
        component: () => import("../views/mypage/ShoppingTradeRequest.vue"),
        name: "ShoppingTradeRequest",
        meta: {
            name: "Trade",
            title: '교환 요청',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/prize/history",
        component: () => import('../views/mypage/PrizeHistory.vue'),
        name: "PrizeHistory",
        beforeEnter: storeSet,
        meta: {
            name: "PrizeHistory", title: "코인몰 교환 내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/ttoba/history",
        component: () => import('../views/mypage/TtobaHistory.vue'),
        name: "TtobaHistory",
        beforeEnter: storeSet,
        meta: {
            name: "TtobaHistory", title: "또바몰 교환 내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/affiliate",
        component: () => import('../views/mypage/Affiliate.vue'),
        name: "Affiliate",
        beforeEnter: storeSet,
        meta: {
            name: "Affiliate", title: "제휴상품 교환내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    // 골드 코인 내역
    {
        path: "/mypage/gold-coin/history",
        component: () => import('../views/mypage/GoldCoinHistory.vue'),
        name: "GoldCoinHistory",
        beforeEnter: storeSet,
        meta: {
            name: "GoldCoinHistory", title: "골드 코인 내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    //

    {
        path: "/mypage/coin/history",
        component: () => import('../views/mypage/CoinHistory.vue'),
        name: "CoinHistory",
        beforeEnter: storeSet,
        meta: {
            name: "CoinHistory", title: "코인/ 포인트내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/coin/history/point",
        component: () => import('../views/mypage/PointHistory.vue'),
        name: "PointHistory",
        beforeEnter: storeSet,
        meta: {
            name: "PointHistory", title: "코인/ 포인트내역",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/coin/exchange",
        component: () => import('../views/mypage/CoinExchange.vue'),
        name: "CoinExchange",
        beforeEnter: storeSet,
        meta: {
            name: "CoinExchange", title: "코인 교환",
            authRequired: true,
            storeRequired: true,
            isGray: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/coupon",
        component: () => import('../views/mypage/MyCoupon.vue'),
        name: "MyCoupon",
        beforeEnter: storeSet,
        meta: {
            name: "MyCoupon",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},

        },

    },
    {
        path: "/mypage/promotion/prize",
        component: () => import('../views/mypage/PromotionPrize.vue'),
        name: "PromotionPrize",
        beforeEnter: storeSet,
        meta: {
            name: "PromotionPrize", title: "상품 프로모션",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/promotion/point",
        component: () => import('../views/mypage/PromotionPoint.vue'),
        name: "PromotionPoint",
        beforeEnter: storeSet,
        meta: {
            name: "PromotionPoint", title: "포인트 프로모션",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/promotion/gold", 
        component: () => import('../views/mypage/PromotionGoldCoin.vue'),
        name: "PromotionGoldCoin",
        beforeEnter: storeSet,
        meta: {
            name: "PromotionGoldCoin", title: "골드 코인 프로모션",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/notice",
        component: () => import('../views/service/Notice.vue'),
        name: "Notice",
        beforeEnter: storeSet,
        meta: {
            name: "Notice", title: "공지사항",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: "/mypage/notice/:idx",
                component: () => import('../views/service/NoticeDetail.vue'),
                name: "NoticeDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "NoticeDetail", title: "공지 상세",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
        ],
    },

    {
        path: "/mypage/terms",
        component: () => import('../views/service/Terms.vue'),
        name: "Terms",
        beforeEnter: storeSet,
        meta: {
            name: "Terms", title: "약관",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: "/mypage/terms/:idx",
                component: () => import('../views/service/TermsDetail.vue'),
                name: "TermsDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "TermsDetail", title: "약관 상세",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
        ],
    },

    {
        path: "/mypage/faq",
        component: () => import('../views/service/Faq.vue'),
        name: "Faq",
        beforeEnter: storeSet,
        meta: {
            name: "Faq", title: "자주 묻는 질문",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },

        children: [
            {
                path: "/mypage/faq/:idx",
                component: () => import('../views/service/FaqDetail.vue'),
                name: "FaqDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "FaqDetail", title: "자주 묻는 질문",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
        ],
    },

    {
        path: "/mypage/qna",
        component: () => import('../views/service/Qna.vue'),
        name: "Qna",
        beforeEnter: storeSet,
        meta: {
            name: "Qna", title: "1:1 문의",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },

        children: [
            {
                path: "/mypage/qna/create",
                component: () => import('../views/service/QnaCreate.vue'),
                name: "QnaCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "QnaCreate", title: "문의 등록",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: "/mypage/qna/:idx",
                component: () => import('../views/service/QnaDetail.vue'),
                name: "QnaDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "QnaDetail", title: "문의 상세",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },

            {
                path: "/mypage/qna/:idx/update",
                component: () => import('../views/service/QnaUpdate.vue'),
                name: "QnaUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "QnaUpdate", title: "문의 수정",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },

        ],
    },


    {
        path: "/mypage/video/create/:type",
        component: () => import('../views/video/VideoCreate.vue'),
        name: "VideoCreate",
        beforeEnter: storeSet,
        meta: {
            name: "VideoCreate", title: "영상 콘텐츠 등록",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/video/update/:idx/:type",
        component: () => import('../views/video/VideoUpdate.vue'),
        name: "VideoUpdate",
        beforeEnter: storeSet,
        meta: {
            name: "VideoUpdate", title: "영상 콘텐츠 수정",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/mypage/video",
        component: () => import('../views/video/Video.vue'),
        name: "Video",
        beforeEnter: storeSet,
        meta: {
            name: "Video", title: "영상 콘텐츠 관리",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: "/mypage/video/:idx",
                component: () => import('../views/video/VideoDetail.vue'),
                name: "VideoDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "VideoDetail", title: "영상 콘텐츠 상세",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: "/mypage/video/shorts/:idx",
                component: () => import('../views/video/MediaShortsDetail.vue'),
                name: "VideoDetailShorts",
                beforeEnter: storeSet,
                meta: {
                    name: "VideoDetailShorts", title: "영상 콘텐츠 상세",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: "/mypage/video/:idx/update/:type",
                component: () => import('../views/video/VideoUpdate.vue'),
                name: "VideoUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "VideoUpdate", title: "영상 콘텐츠 수정",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
        ]
    },

    {
        path: "/mypage/feed-referee-code",
        component: () => import('../views/mypage/RefereeCodeFeed.vue'),
        name: "RefereeCodeFeed",
    },

    // 쇼핑 콘텐츠 관리
    // {
    //     path: "/shopping",
    //     component: () => import('../views/shopping/Shopping.vue'),
    //     name: "Shopping",
    //     beforeEnter: storeSet,
    //     meta: {
    //         name: "Shopping", title: "쇼핑 콘텐츠 관리",
    //         authRequired: true,
    //         storeRequired: true,
    //         storeConfig: {userInfo: true},
    //     },
    //     children: [
    //         {
    //             path: "/shopping/create",
    //             component: () => import('../views/shopping/ShoppingCreate.vue'),
    //             name: "ShoppingCreate",
    //             beforeEnter: storeSet,
    //             meta: {
    //                 name: "ShoppingCreate", title: "쇼핑 콘텐츠 등록",
    //                 authRequired: true,
    //                 storeRequired: true,
    //                 isChild: true,
    //                 storeConfig: {userInfo: true},
    //             },
    //         },
    //         {
    //             path: "/shopping/:idx/update",
    //             component: () => import('../views/shopping/ShoppingUpdate.vue'),
    //             name: "ShoppingUpdate",
    //             beforeEnter: storeSet,
    //             meta: {
    //                 name: "ShoppingUpdate", title: "쇼핑 콘텐츠 수정",
    //                 authRequired: true,
    //                 storeRequired: true,
    //                 isChild: true,
    //                 storeConfig: {userInfo: true},
    //             },
    //         },
    //         {
    //             path: "/shopping/:idx",
    //             component: () => import('../views/shopping/ShoppingDetail.vue'),
    //             name: "ShoppingDetail",
    //             beforeEnter: storeSet,
    //             meta: {
    //                 name: "ShoppingDetail", title: "쇼핑 콘텐츠 상세",
    //                 authRequired: true,
    //                 storeRequired: true,
    //                 isChild: true,
    //                 storeConfig: {userInfo: true},
    //             },
    //         },
    //
    //     ]
    // },


    // TODOD 20260407 쇼핑 주석처리
    // {
    //     path: "/shopping/:idx/purchase",
    //     component: () => import('../views/shopping/ShoppingPurchase.vue'),
    //     name: "ShoppingPurchase",
    //     beforeEnter: storeSet,
    //     meta: {
    //         name: "ShoppingPurchase", title: "쇼핑 상품 구매",
    //         authRequired: true,
    //         storeRequired: true,
    //         storeConfig: {userInfo: true},
    //     }
    // },
    // {
    //     path: "/shopping/:idx/purchase/detail",
    //     component: () => import('../views/shopping/ShoppingPurchaseDetail.vue'),
    //     name: "ShoppingPurchaseDetail",
    //     beforeEnter: storeSet,
    //     meta: {
    //         name: "ShoppingPurchaseDetail", title: "레인보우 쇼핑 구매",
    //         authRequired: true,
    //         storeRequired: true,
    //         storeConfig: {userInfo: true},
    //     }
    // },

    {
        path: "/shopping/:idx/pay/success",
        component: () => import('../views/shopping/ShoppingPurchaseComplete.vue'),
        name: "ShoppingPurchaseComplete",
        beforeEnter: storeSet,
        meta: {
            name: "ShoppingPurchaseComplete", title: "레인보우 쇼핑 완료",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        }
    },

    {
        path: "/vod/:idx/pay/success",
        component: () => import('../views/video/VodPurchaseComplete.vue'),
        name: "VodPurchaseComplete",
        beforeEnter: storeSet,
        meta: {
            name: "VodPurchaseComplete", title: "레인보우 VOD 완료",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        }
    },


    {
        path: "/ad/create",
        component: () => import('../views/ad/AdCreateSelectItem.vue'),
        name: "AdCreateSelectItem",
        beforeEnter: storeSet,
        meta: {
            name: "AdCreateSelectItem",
            title: "광고 콘텐츠 등록",
            authRequired: true,
            storeRequired: true,
            isChild: false,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/ad/create/:type/:idx",
        component: () => import('../views/ad/AdCreate.vue'),
        name: "AdCreate",
        beforeEnter: storeSet,
        meta: {
            name: "AdCreate", title: "광고 콘텐츠 등록",
            authRequired: true,
            storeRequired: true,
            isChild: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/ad",
        component: () => import('../views/ad/Ad.vue'),
        name: "Ad",
        beforeEnter: storeSet,
        meta: {
            name: "Video", title: "광고 콘텐츠 관리",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: ':idx/pay',
                component: () => import('../views/ad/AdPay.vue'),
                name: "AdPay",
                beforeEnter: storeSet,
                meta: {
                    name: "AdPay", title: "광고 결제",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: '/ad/:idx',
                component: () => import('../views/ad/AdDetail.vue'),
                name: "AdDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "AdDetail", title: "광고 상세",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: '/ad/:idx/:type/update',
                component: () => import('../views/ad/AdUpdate.vue'),
                name: "AdUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "AdUpdate", title: "광고 수정",
                    authRequired: true,
                    storeRequired: true,
                    isChild: true,
                    storeConfig: {userInfo: true},
                },
            },
        ],
    },
    {
        path: '/ad/:idx/pay/success',
        component: () => import('../views/ad/AdPaySuccess.vue'),
        name: "AdPaySuccess",
        beforeEnter: storeSet,
        meta: {
            name: "AdPaySuccess", title: "광고 결제",
            authRequired: true,
            isChild: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },


    {
        path: '/pay/result/success',
        component: () => import('../views/pay/PaySuccess.vue'),
        beforeEnter: storeSet,
        name: 'PaySuccess',
        meta: {
            name: "MediaUpdate",
            title: "결제",
            main: '결제',
            sideHidden: true,
            mainClass: '',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/pay/result/fail',
        component: () => import('../views/pay/PayFail.vue'),
        beforeEnter: storeSet,
        name: 'PayFail',
        meta: {
            name: "PayFail",
            title: "결제",
            main: '결제',
            sideHidden: true,
            mainClass: '',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/certi/parent",
        component: () => import("../views/agree/AgreeCertified.vue"),
        name: "AgreeCertified",
        // beforeEnter: storeSet,
        meta: {
            name: "AgreeCertified",
            title: '미성년자 결제 보호자 동의',
            // authRequired: true,
        },
    },
    {
        path: "/certi/parent/result",
        component: () => import("../views/agree/AgreeNiceResult.vue"),
        name: "AgreeNiceResult",
        meta: {
            name: "AgreeNiceResult",
            title: '미성년자 결제 보호자 동의'
        },
    },
    {
        path: "/certi/parent/finish",
        component: () => import("../views/agree/AgreeCertifiedFinish.vue"),
        name: "AgreeCertifiedFinish",
        meta: {
            name: "AgreeCertifiedFinish",
            title: '미성년자 결제 보호자 동의'
        },
    },
    {
        path: "/suspend",
        component: () => import("../views/auth/Suspend.vue"),
        name: "Suspend",
        meta: {
            name: "Suspend",
            title: '정지 해제'
        },
    },
    {
        path: "/expiration",
        component: () => import("../views/auth/Expiration.vue"),
        name: "Expiration",
        meta: {
            name: "Suspend",
            title: '재인증'
        },
    },


    {
        path: "/mission",
        component: () => import('../views/mission/Mission.vue'),
        name: "Mission",
        beforeEnter: storeSet,
        meta: {
            name: "Mission", title: "이벤트",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
            children: [
                {
                    path: "attendance",
                    component: () => import('../views/mission/MissionAttendance.vue'),
                    name: "MissionAttendance",
                    beforeEnter: storeSet,
                    meta: {
                        name: "MissionAttendance",
                        title: "연속출석 미션",
                        authRequired: true,
                        storeRequired: true,
                        storeConfig: {userInfo: true},
                        sideMenu: false,
                    },
                },

            ]
        },
    },
    {
        path: '/ttoba',
        component: () => import('../views/gift/Ttoba.vue'),
        name: "Ttoba",
        beforeEnter: storeSet,
        meta: {
            name: "Ttoba",
            title: "또바몰",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/ttoba/:ttobaCategoryIdx',
        component: () => import('../views/gift/TtobaDetail.vue'),
        name: "TtobaDetail",
        beforeEnter: storeSet,
        meta: {
            name: "TtobaDetail",
            title: "\uB610\uBC14\uBAB0 \uC0C1\uC138",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/event',
        component: () => import('../views/gift/Event.vue'),
        name: "Event",
        beforeEnter: storeSet,
        meta: {
            name: "Event",
            title: "이벤트",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/roulette",
        component: () => import("../views/roulette/Roulette.vue"),
        name: "Roulette",
        meta: {
            name: "Roulette", title: "룰렛",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: "/preview",
        component: () => import('../views/preview/Preview.vue'),
        name: "Preview",
        beforeEnter: storeSet,
        meta: {
            name: "Preview", title: "미리보기",
        },

    },
    {
        path: "/preview/mobile",
        component: () => import('../views/preview/PreviewMobile.vue'),
        name: "PreviewMobile",
        beforeEnter: storeSet,
        meta: {
            name: "PreviewMobile", title: "미리보기",
        },

    },
    {
        path: '/unity/:type',
        component: () => import('../views/auth/UnityLogin.vue'),
        name: 'Unity',
        meta: {background: true,}
    },
    {
        path: "/:vodType/:meIdx/purchase/:purchaseType",
        component: () => import('../views/video/VideoPurchase.vue'),
        name: "VideoPurchase",
        beforeEnter: storeSet,
        meta: {
            name: "VideoPurchase",
            title: "결제",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/redirect',
        component: () => import('../views/Redirect.vue'),
        name: 'Redirect',
        meta: {background: true,}
    },
    { //심사에 필요한 정보입니다. 제발제발제발 날리지말아주세요.
        path: "/contact",
        component: () => import('../views/Contact.vue'),
        meta: {
            name: "Contact", title: "Contact",
        },
    },
    {
        path: '/privacy',
        component: () => import('../views/terms/Privacy.vue'),
        name: 'Privacy',
        meta: {
            name: "Privacy",
            title: "약관",
            main: '약관',
            sideHidden: true,
            mainClass: '',
        },
    },
    {
        path: '/service',
        component: () => import('../views/terms/ServiceTerms.vue'),
        name: 'ServiceTerms',
        meta: {
            name: "ServiceTerms",
            title: "약관",
            main: '약관',
            sideHidden: true,
            mainClass: '',
        },
    },
    {
        path: '/policy',
        component: () => import('../views/terms/ServiceTerms.vue'),
        name: 'PolicyTerms',
        meta: {
            name: "PolicyTerms",
            title: "약관",
            main: '약관',
            sideHidden: true,
            mainClass: '',
        },
    },

    {
        path: "/adult/certified",
        component: () => import("../views/adult/AdultCertified.vue"),
        name: "AdultCertified",
        meta: {
            name: "AdultCertified",
            title: '성인 인증'
        },
    },
    {
        path: "/adult/certified/result",
        component: () => import("../views/adult/AdultCertifiedResult.vue"),
        name: "AdultCertifiedResult",
        meta: {
            name: "AdultCertifiedResult",
            title: '성인 인증'
        },
    },
    {
        path: "/adult/certified/finish",
        component: () => import("../views/adult/AdultCertifiedFinish.vue"),
        name: "AdultCertifiedFinish",

        meta: {
            name: "AdultCertifiedFinish",
            title: '성인 인증',

        },
    },
];
